<!-- color-selector.component.html -->
<!-- Taustalla himmennetty overlay -->
<div class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50 animate-fade animate-duration-300 animate-ease-out" (click)="onOverlayClick($event)">
    <!-- Varactual modal-laatikko -->
    <div class="bg-white rounded-lg p-6 w-full max-w-7xl mx-4 flex flex-col relative h-[80vh] overflow-y-auto">

        <div class="shrink-0 mb-4">
            <!-- Ylätunniste: otsikko + sulkunappi -->
            <div class="flex items-center justify-between mb-4">
                <h2 class="text-xl font-bold text-secondary-500">Select color</h2>
                <button class="text-4xl leading-none text-secondary-500 hover:text-secondary-800" (click)="closeModal.emit()">&times;</button>
            </div>

            <!-- HAKU -->
            <div class="mb-4">
                <input
                        type="text"
                        placeholder="Search by product code or name..."
                        class="w-full border border-gray-300 rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-400"
                        (input)="onSearch($event)"
                />
            </div>
        </div>

        <div class="flex-1 overflow-y-auto scrollable-area space-y-6">

            <!-- RECENT PRODUCTS -->
            @if(recentProducts().length > 0) {
                <div>
                    <h3 class="font-semibold text-xl mb-2 text-slate-700">Aikaisemmat: </h3>
                    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        @for (product of recentProducts(); track product) {
                            <div class="relative group cursor-pointer overflow-hidden border hover:shadow-md transition-all border-slate-200 animate-fade animate-duration-300 animate-ease-out"
                                 (click)="onSelect(product)">

                                <div class="absolute bottom-1 left-1 right-1 text-center text-base font-semibold drop-shadow capitalize">
                                    {{ product.productName }}
                                    <span class="text-slate-500 text-sm"> - {{product.depth}}x{{product.height}} </span>
                                </div>
                                <img class="w-fit" [src]="'/api/storage/view/'+product.coverImage"  alt="coverimage"/>
                            </div>
                        }
                    </div>
                </div>
            }

            <!-- PRODUCTS CATEGORIZED BY FAMILIES -->
            @for (productFamily of groupedProducts(); track productFamily; let i = $index){
                <div>
                    <h3 class="font-semibold text-xl mb-2 text-slate-700">{{ productFamily[0]?.lamellaCategory}}</h3>
                    <div class="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3">
                        @for (product of productFamily; track product;) {

                            <div class="relative group cursor-pointer overflow-hidden border hover:shadow-md transition-all border-slate-200 animate-fade animate-duration-300 animate-ease-out"
                                 (click)="onSelect(product)">

                                <h4 class="absolute bottom-1 left-1 right-1 text-center font-semibold drop-shadow">
                                    {{ product.productName }}
                                    <span class="text-slate-500 text-sm"> - {{product.depth}}x{{product.height}} </span>
                                </h4>
                                <img class="w-fit" [src]="'/api/storage/view/'+product.coverImage"  alt="{{ product.productName }}"/>

                            </div>
                        }
                    </div>
                </div>
            }

        </div>

    </div>
</div>